// Modules
import React from "react";
// @ts-ignore
import {LocalizationContext} from 'react-localize';

// Interfaces
import ResortResult from "Interfaces/ResortResultInterface";
import Item from "Interfaces/ItemInterface";
import FilterResult from "Interfaces/FilterResultInterface";
import SelectedFilters from "Interfaces/SelectedFiltersInterface";

// Components
import MvToggle from "Generic/MvToggle";
import {MvResortModal} from "Generic/MvModal"
import ResultSingleItem from "./ResultSingleItem";
import MvCheckBox from "Generic/MvCheckBox";
import ResortInfo from './ResortInfo/ResortInfo';
import FilterResults from "Components/PWAS/Components/SearchResults/FilterResults";
import MvFilterBtn from "Generic/Buttons/MvFilterBtn";
import { logAnalyticData, trackAnalyticData } from "Utils/analytics";
import moment from "moment";

type SearchResultsState = {
    showOnlyAvailable: boolean,
    modalPropertyCode: string,
    filteredResorts: undefined[],
    sortChecked: boolean,
    propCode: string,
    resortModal: {
        show: boolean;
        propertyCode: string;
    };
};

type Props = {
    onRemoveItem(propertyCode: string): void;
    results: ResortResult[];
    filters: FilterResult;
    showAvailability(propertyCode: any, selectedFilters: SelectedFilters, waitlistToggleChecked: boolean): void;
    arrangeResults: (sortBy: string) => void;
    toggleFilterGroup(name: string, boolean?: boolean): void;
    selectedFilters: SelectedFilters;
    onFilterSelect(name: string, item: any): void;
    clearFilters(): void;
    pointsSearch?: string;
}

class SearchResults extends React.Component<Props, SearchResultsState> {
    style = {
        borderBottom: "1px solid #F0F0F0F0"
    };

    constructor(props: Props) {
        super(props);
        this.toggleUnavailable = this.toggleUnavailable.bind(this);
        this.removeItem = this.removeItem.bind(this);
        this.showAvailability = this.showAvailability.bind(this);
        this.onSortResults = this.onSortResults.bind(this);
        this.toggleResortModal = this.toggleResortModal.bind(this)
        this.changePropCode = this.changePropCode.bind(this)
        this.getResortInfo = this.getResortInfo.bind(this)

        this.state = {
            showOnlyAvailable: false,
            filteredResorts: [],
            modalPropertyCode: "",
            sortChecked: false,
            propCode: "",
            resortModal: {
                show: false,
                propertyCode: '',
            },
        };
    }
    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<SearchResultsState>, snapshot?: any): void {
        if(prevProps.results != this.props.results) {
                const filterData = JSON.parse(sessionStorage.getItem('OPS_Form') || '{}');
                let amountWithResults = 0;
                let filtered = this.props.results ? this.filter(this.props.results, this.props.selectedFilters) : [];
                let list = this.props.results ? this.props.results
                    .filter(resort => {
                        amountWithResults = amountWithResults + (resort.available[0] && (filtered.indexOf(resort.propertyCode) === -1 || filtered.length === 0) ? 1 : 0)
                        return (
                            !this.state.showOnlyAvailable ||
                            (resort.available[0] &&
                                (!this.state.showOnlyAvailable ||
                                    filtered.indexOf(resort.propertyCode) === -1))
                        );
                    })
                    : []
                
                const checkoutDate = moment(filterData.startDate).add(filterData.numNights, 'days')

                /**
                 * PWAS Aanalytics when clicked on omni present search button 
                 */
                logAnalyticData({ event: 'Search Resorts', siteSection: 'Points Reservation', pageName:'Book My Holiday', website:'' }, {
                    ownerActivity: 'Points Reservation',
                    step:'Step 2: Search Results',
                    errorMessagfe:"",
                    notificationType: "",
                    searchedCheckInDate:filterData.startDate,
                    searchedActivity: filterData.activity,
                    searchedLengthofStay:filterData.numNights,
                    inventoryChanged:"",
                    searchedCheckOutDate:moment(checkoutDate).format('MM/DD/YYYY'),
                    searchedGuestQuantity:filterData.numGuests,
                    noResultsReturned:amountWithResults,
                    noResortsSearched:filterData.resorts.length,
                    typeOfSearch:filterData.searchType ? 'True' : 'False',
                    searchedResorts:filterData.resorts,
                    searchedDestination:"",
                    bookingWindow:""
                    
                })
                trackAnalyticData('points:step2');
        }
    }

    onSortResults(e: React.ChangeEvent<HTMLInputElement>) {
        this.setState({sortChecked: !this.state.sortChecked})
        if (e.target.checked) {
            this.props.arrangeResults("LOCATION");

        } else {
            this.props.arrangeResults("");

        }
    }

    showAvailability(propertyCode: string, waitlistToggleChecked: boolean) {
        this.props.showAvailability(propertyCode, this.props.selectedFilters, waitlistToggleChecked);
    }

    filter(resortList: ResortResult[], selectedFilters: SelectedFilters) {
        return resortList
            .filter(resort => {
                let availableRoomTypes = resort.available.flat().map(room => room.roomType);
                let unAvailableRoomTypes = (resort.unavailable || []).flat().map(room => room.roomType);
                let activities = resort.activities.map(x=> x.name);
                let hasActivity = selectedFilters["activity"].filters.some(
                    (act: any) => {
                        return ((activities.indexOf(act)) > -1);
                    }
                );
                let hasAvailableRoomType = selectedFilters["roomType"].filters.some(
                    (rt: string) => availableRoomTypes.indexOf(rt) > -1 
                );
                let hasUnAvailableRoomType = selectedFilters["roomType"].filters.some(
                    (rt: string) => unAvailableRoomTypes.indexOf(rt) > -1 
                );
                return !(
                    (selectedFilters["area"].filters.length === 0 ||
                        selectedFilters["area"].filters.indexOf(resort.city) > -1) &&
                    (selectedFilters["activity"].filters.length === 0 || hasActivity) &&
                    (selectedFilters["roomType"].filters.length === 0 || hasAvailableRoomType || hasUnAvailableRoomType)
                );
            })
            .map(resort => {
                return resort.propertyCode;
            });
    }

    toggleUnavailable() {
        let state = this.state;
        this.setState({
            showOnlyAvailable: !state.showOnlyAvailable
        });
    }

    removeItem(propertyCode: string) {
        this.props.onRemoveItem(propertyCode);
    }

    toggleMobileFilter() {
        let el:any = document.getElementById('html')
        let box:any = document.getElementById('filter-box');

        box.classList.toggle("display")
        el.classList.toggle("overflow")
    }

    toggleResortModal(propertyCode: string) {
        this.setState({
            resortModal: {
                propertyCode,
                show: !this.state.resortModal.show,
            },
        });
    }

    changePropCode(propCode: string) {
        this.setState({
            propCode: propCode
        });
    }

     getResortInfo(propCode: string) {
        this.props.results.filter(pc => pc.propertyCode === propCode )
      }

    render() {
        const {localize} = this.context;

        let filterLengths = (this.props.selectedFilters.roomType.filters.length + this.props.selectedFilters.views.filters.length + this.props.selectedFilters.activity.filters.length + this.props.selectedFilters.area.filters.length);
        let filtered = this.props.results ? this.filter(this.props.results, this.props.selectedFilters) : [];
        let amountWithResults = 0;

        let list = this.props.results ? this.props.results
            .filter(resort => {
                amountWithResults = amountWithResults + (resort.available[0] && (filtered.indexOf(resort.propertyCode) === -1 || filtered.length === 0) ? 1 : 0)
                return (
                    !this.state.showOnlyAvailable ||
                    (resort.available[0] &&
                        (!this.state.showOnlyAvailable ||
                            filtered.indexOf(resort.propertyCode) === -1))
                );
            })
            .map(results => {
                return (
                    <ResultSingleItem
                        key={results.propertyCode}
                        onRemoveItem={this.removeItem}
                        openModal={() => this.toggleResortModal(results.propertyCode)}
                        result={results}
                        filtered={filtered.indexOf(results.propertyCode) > -1}
                        pointsSearch={this.props.pointsSearch}
                        showAvailability={(waitlistToggleChecked: boolean) => this.props.showAvailability(results, this.props.selectedFilters, waitlistToggleChecked)}
                    />
                );
            }) : [];

        let filteredTotal = this.props.results ? this.props.results.length - filtered.length : 0

        return (
            <React.Fragment>
                <MvResortModal
                    show={this.state.resortModal.show}
                    propertyCode={this.state.resortModal.propertyCode}
                    toggle={() => this.setState({ resortModal: { ...this.state.resortModal, show: !this.state.resortModal.show } })}
                />

                <div className="search-results row">
                    <div className="results-list columns ten">
                        <div id="results-availability-status" className="row">
                            <p className="six columns search-status">
                                {localize("static.content.we-found")} {amountWithResults} {localize("static.content.of")} {filteredTotal}{" "}
                                {localize("static.content.resorts-have-availability")}.
                            </p>
                            <div className="three columns hide-unavailable">
                                <MvToggle
                                    label={this.state.showOnlyAvailable ? localize("static.content.show-all") : localize("static.content.hide-unavailable")}
                                    checked={this.state.showOnlyAvailable}
                                    onChange={this.toggleUnavailable}
                                    name="n/a"
                                    ariaLabel="Toggle between hiding unavailable resorts and showing all"
                                    tabIndex={0}
                                />
                            </div>
                            <div className="sort-by-location" style={{marginRight:30}}>
                                <MvCheckBox
                                    label={localize("static.content.sort-by-location")}
                                    onChange={this.onSortResults}
                                    checked={this.state.sortChecked}
                                    id={"sortBy"}
                                />
                            </div>
                        </div>
                        <ul className="result-list-wrapper">
                            <div className="mobile-filter-toggle">
                              <MvFilterBtn onClick={this.toggleMobileFilter} />
                            </div>
                            {list}
                        </ul>
                    </div>
                    <FilterResults

                      filters={this.props.filters}
                      selectedFilters={this.props.selectedFilters}
                      onSelect={this.props.onFilterSelect}
                      onClear={this.props.clearFilters}
                      toggleOpen={this.props.toggleFilterGroup}
                      disableActivitiesFilter={false}
                      disableAreaFilter={false}
                      disableViewFilter={true}
                      disableClearFilter={false}
                      disableRoomTypeFilter={false}
                    />
                </div>

            </React.Fragment>
        );
    }
}

SearchResults.contextType = LocalizationContext;

export default SearchResults;
